<template>
  <div class="tab">
    <ul v-if="plan.evidencias.length" class="lista">
      <li v-for="e in plan.evidencias" :key="e.idEvidencia" class="item">
        <div class="item-cab">
          <div>
            <div class="nombre">{{ e.nombre }}</div>
            <div v-if="e.descripcion" class="desc">{{ e.descripcion }}</div>
            <div class="meta">
              {{ e.cargadaPor || "—" }} · {{ fmtFecha(e.fechaCarga) }}
              <span v-if="e.version > 1"> · versión {{ e.version }}</span>
            </div>
          </div>
          <PortalBadge :text="etiqueta(e.estatus)" :color="color(e.estatus)" />
        </div>

        <!-- RN-15: el motivo del rechazo se conserva y se muestra siempre. -->
        <p v-if="e.comentarioRechazo" class="rechazo">
          <strong>Motivo del rechazo:</strong> {{ e.comentarioRechazo }}
        </p>

        <div v-if="puedeRevisar && e.estatus === 'pendiente_revision'" class="acciones">
          <button class="btn aprobar" @click="$emit('aprobar', e)">Aprobar</button>
          <button class="btn rechazar" @click="$emit('rechazar', e)">Rechazar</button>
        </div>
      </li>
    </ul>

    <p v-else class="vacio">
      Sin evidencias. Se necesita al menos una para enviar el plan a validación,
      y una aprobada para cerrarlo.
    </p>

    <div v-if="editable" class="alta">
      <div class="alta-titulo">Cargar evidencia</div>
      <!-- Limitación conocida del MVP: la evidencia se registra como referencia
           (nombre + descripción + enlace). La carga binaria del archivo está
           pendiente — riesgo R5 del plan de implementación. -->
      <p class="alta-nota">
        Por ahora se registra la referencia a la evidencia, no el archivo. Usa el
        enlace al documento en el repositorio corporativo.
      </p>
      <div class="alta-grid">
        <label class="field campo-ancho">
          <span class="field-label">Nombre</span>
          <input v-model="f.nombre" class="inp" placeholder="Ej. Acta de cierre firmada" />
          <span v-if="errores.nombre" class="field-error">{{ errores.nombre }}</span>
        </label>
        <label class="field campo-ancho">
          <span class="field-label">Enlace</span>
          <input v-model="f.urlExterna" class="inp" placeholder="https://… (opcional)" />
        </label>
      </div>
      <label class="field">
        <span class="field-label">Descripción</span>
        <textarea
          v-model="f.descripcion"
          rows="2"
          class="inp"
          placeholder="Qué demuestra esta evidencia (opcional)"
        ></textarea>
      </label>
      <button
        class="btn-add"
        :disabled="agregando"
        :style="{ background: agregando ? '#cbd5e1' : '#003ca5' }"
        @click="agregar"
      >
        {{ agregando ? "Cargando…" : "Cargar evidencia" }}
      </button>
    </div>
  </div>
</template>

<script>
import PortalBadge from "../PortalBadge.vue";
import { fmtFecha } from "../cx.rules";
import { validaEvidencia } from "../cx.validators";

const ETIQUETAS = {
  pendiente_revision: "Pendiente de revisión",
  aprobada: "Aprobada",
  rechazada: "Rechazada",
  reemplazada: "Reemplazada",
};
const COLORES = {
  pendiente_revision: "#d97706",
  aprobada: "#16a34a",
  rechazada: "#dc2626",
  reemplazada: "#94a3b8",
};

export default {
  name: "TabEvidencias",
  components: { PortalBadge },
  props: {
    plan: { type: Object, required: true },
    editable: { type: Boolean, default: false },
    puedeRevisar: { type: Boolean, default: false },
    agregando: { type: Boolean, default: false },
  },
  emits: ["agregar-evidencia", "aprobar", "rechazar"],
  data() {
    return { errores: {}, f: { nombre: "", descripcion: "", urlExterna: "" } };
  },
  methods: {
    fmtFecha,
    etiqueta: (e) => ETIQUETAS[e] || e,
    color: (e) => COLORES[e] || "#64748b",
    agregar() {
      if (this.agregando) return;
      const r = validaEvidencia(this.f);
      this.errores = r.errores;
      if (!r.ok) return;
      this.$emit("agregar-evidencia", { ...this.f });
      this.f = { nombre: "", descripcion: "", urlExterna: "" };
      this.errores = {};
    },
  },
};
</script>

<style scoped>
.tab {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.lista {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.item {
  border: 1px solid var(--pt-border);
  border-radius: 12px;
  padding: 12px 14px;
}
.item-cab {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.nombre {
  font-weight: 600;
  font-size: 14px;
}
.desc {
  font-size: 13px;
  color: var(--pt-dim);
  margin-top: 2px;
}
.meta {
  font-size: 11px;
  color: var(--pt-muted);
  margin-top: 4px;
}
.rechazo {
  margin: 8px 0 0;
  font-size: 13px;
  color: #b91c1c;
  background: #fef2f2;
  border-radius: 8px;
  padding: 8px 10px;
}
.acciones {
  display: flex;
  gap: 8px;
  margin-top: 10px;
}
.btn {
  padding: 6px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  border: 0;
  cursor: pointer;
  color: #fff;
  font-family: inherit;
}
.aprobar {
  background: #16a34a;
}
.rechazar {
  background: #dc2626;
}
.vacio {
  font-size: 14px;
  color: var(--pt-muted);
  text-align: center;
  padding: 24px 0;
  margin: 0;
}
.alta {
  border-top: 1px solid var(--pt-border);
  padding-top: 14px;
}
.alta-titulo {
  font-size: 12px;
  font-weight: 700;
  color: var(--pt-dim);
}
.alta-nota {
  font-size: 11px;
  color: var(--pt-muted);
  margin: 4px 0 10px;
}
.alta-grid {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}
.campo-ancho {
  flex: 1;
  min-width: 200px;
}
.field {
  display: block;
  margin-bottom: 10px;
}
.field-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: var(--pt-dim);
  margin-bottom: 4px;
}
.inp {
  width: 100%;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 14px;
  border: 1px solid var(--pt-border);
  outline: none;
  background: var(--pt-card);
  color: var(--pt-text);
  box-sizing: border-box;
  font-family: inherit;
  resize: none;
}
.inp:focus {
  border-color: #003ca5;
}
.field-error {
  display: block;
  margin-top: 4px;
  font-size: 12px;
  color: #b91c1c;
}
.btn-add {
  padding: 9px 18px;
  border: 0;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  font-family: inherit;
}
.btn-add:disabled {
  cursor: not-allowed;
}
</style>
